<!-- <page-title [icon]="icon" [name]="translate('title')"></page-title> -->
{{ translate('title')}}
